/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ConfigDTO,
    ConfigDTOFromJSON,
    ConfigDTOToJSON,
} from '../models';

/**
 * 
 */
export class ConfigControllerApi extends runtime.BaseAPI {

    /**
     */
    async getRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ConfigDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/general/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigDTOFromJSON(jsonValue));
    }

    /**
     */
    async get(initOverrides?: RequestInit): Promise<ConfigDTO> {
        const response = await this.getRaw(initOverrides);
        return await response.value();
    }

}
